import { useEffect, useState, useCallback } from 'react';

const useOtpCountdown = (durationSeconds) => {
    const [secondsLeft, setSecondsLeft] = useState(durationSeconds);

    useEffect(() => {
        const interval = setInterval(() => {
            setSecondsLeft((prev) => (prev > 0 ? prev - 1 : 0));
        }, 1000);
        return () => clearInterval(interval);
    }, []);

    const reset = useCallback(() => setSecondsLeft(durationSeconds), [durationSeconds]);

    const minutes = String(Math.floor(secondsLeft / 60)).padStart(2, '0');
    const seconds = String(secondsLeft % 60).padStart(2, '0');

    return { secondsLeft, formatted: `${minutes}:${seconds}`, reset, expired: secondsLeft <= 0 };
};

export default useOtpCountdown;
